import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import ModalDialog from './modal-dialog';
var gt = i18n.getFixedT(null, 'app');
var initialState = JSON.parse(document.getElementById('initial-state').innerHTML || '{}');
var cfg = initialState.envCfg;
/**
 * A React Marquee
 * @constructor
 * @param {string} [className] - Component class name.
 * @param {Array.<object>} [dataList] - List of data. The sequence need to sort high to low by dateTime.
 * @param {string} [dataList.title] - Message title.
 * @param {string} [dataList.description] - Message description.
 * @param {boolean} [enableDialog] - Eable marquee dialog function. Default value is true.
 * @param {string} [direction] - directions: downToUp, upToDown, leftToRight, rightToLeft, defaultValue: downToUp.
 * 
// controlled
import Marquees from './Marquees'
<Marquees 
    dataList={[
        {
            id: '{1asdf}',
            title: '高港高架北向壅塞(里程3398-3198)',
            description: '壅塞事件]高港高架北向壅塞(里程3398-3198)，嚴重程度0，通報時間：2021-12-23 09:55:21',
            source: '交通局',
            dateTime: 1666059000000
        }
    ]}
/>
 */

var Marquees = /*#__PURE__*/React.memo(function (props) {
  var dataList = props.dataList,
      enableDialog = props.enableDialog;

  var _useState = useState(dataList),
      _useState2 = _slicedToArray(_useState, 2),
      marqueeList = _useState2[0],
      setMarqueeList = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialog = _useState4[0],
      setOpenDialog = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      dialogData = _useState6[0],
      setDialogData = _useState6[1];

  var _isMounted = useRef(false);

  var marqueeRef = useRef();
  useEffect(function () {
    if (!_isMounted.current) return;
    setMarqueeList(dataList);
  }, [dataList]);

  var handleListSort = function handleListSort(firstIndex, list) {
    var sortedList = _.cloneDeep(list);

    sortedList.push(sortedList[0]);
    sortedList.shift();
    if (firstIndex - 1 <= 0) return sortedList;else return handleListSort(firstIndex - 1, sortedList);
  };

  useEffect(function () {
    _isMounted.current = true;
    return function () {};
  }, []);

  var handleOpenDialog = function handleOpenDialog(data) {
    setOpenDialog(true);
    setDialogData(data);
  };

  var handleCloseDailog = function handleCloseDailog() {
    setOpenDialog(false);
    setDialogData(null);
  };

  if (_.isEmpty(dataList) || dataList.length === 0) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("marquee", {
    width: "100%",
    direction: "left",
    ref: marqueeRef,
    onMouseOver: function onMouseOver() {
      return marqueeRef.current.stop();
    },
    onMouseOut: function onMouseOut() {
      return marqueeRef.current.start();
    },
    className: "marquee-old"
  }, _.map(marqueeList, function (el, index) {
    return /*#__PURE__*/React.createElement("span", {
      className: "marquee-content-item",
      title: el.title,
      key: index,
      onClick: function onClick() {
        return handleOpenDialog(el);
      }
    }, " ".concat(gt('global.lbl-instant-message'), ": ").concat(el.title));
  })), enableDialog && openDialog && /*#__PURE__*/React.createElement(MarqueesDialog, {
    data: dialogData,
    onCloseDailog: handleCloseDailog
  }));
});
Marquees.defaultProps = {
  newsList: [],
  enableDialog: true
};
Marquees.propTypes = {
  newsList: PropTypes.array,
  className: PropTypes.string,
  enableDialog: PropTypes.bool
};
export default Marquees;

var MarqueesDialog = function MarqueesDialog(props) {
  var data = props.data,
      onCloseDailog = props.onCloseDailog;
  var contextRoot = cfg.contextRoot;
  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: onCloseDailog
  });

  var handleDownloadPdf = function handleDownloadPdf(filePath) {
    fetch("".concat(contextRoot, "/fileServer").concat(filePath)).then(function (response) {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }

      return response.blob();
    }).then(function (blob) {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filePath.split('/').pop();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }).catch(function (error) {
      console.error('Error downloading PDF:', error);
    });
  };

  var checkImageIsExist = function checkImageIsExist() {
    if (data !== null && data !== void 0 && data.imagePath1 || data !== null && data !== void 0 && data.imagePath2 || data !== null && data !== void 0 && data.imagePath3) {
      return true;
    }

    return false;
  };

  var checkLinksIsExist = function checkLinksIsExist() {
    if (data !== null && data !== void 0 && data.linkUrl1 || data !== null && data !== void 0 && data.linkUrl2 || data !== null && data !== void 0 && data.linkUrl3) {
      return true;
    }

    return false;
  };

  var renderLink = function renderLink(linkUrl, linkName) {
    if (!linkUrl) {
      return null;
    }

    return /*#__PURE__*/React.createElement("a", {
      className: "link",
      href: linkUrl,
      target: "_blank"
    }, linkName);
  };

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: 'marquees',
    title: gt('global.lbl-instant-message'),
    contentClassName: 'marquees-dialog',
    global: true,
    actions: actions
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, data.title), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, _.map(_.split(data.description, /\r?\n/g), function (text) {
    return /*#__PURE__*/React.createElement("div", null, text);
  })), checkLinksIsExist() && /*#__PURE__*/React.createElement("div", {
    className: "links"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, gt('marquees.lbl-links'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "links-url"
  }, renderLink(data === null || data === void 0 ? void 0 : data.linkUrl1, data === null || data === void 0 ? void 0 : data.linkName1), renderLink(data === null || data === void 0 ? void 0 : data.linkUrl2, data === null || data === void 0 ? void 0 : data.linkName2), renderLink(data === null || data === void 0 ? void 0 : data.linkUrl3, data === null || data === void 0 ? void 0 : data.linkName3))), (data === null || data === void 0 ? void 0 : data.pdfPath1) && /*#__PURE__*/React.createElement("div", {
    className: "file"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, gt('marquees.lbl-file'), ":"), /*#__PURE__*/React.createElement("a", {
    className: "link",
    onClick: function onClick() {
      return handleDownloadPdf(data === null || data === void 0 ? void 0 : data.pdfPath1);
    }
  }, data === null || data === void 0 ? void 0 : data.pdfPath1.split('/').pop())), checkImageIsExist() && /*#__PURE__*/React.createElement("div", {
    className: "images"
  }, (data === null || data === void 0 ? void 0 : data.imagePath1) && /*#__PURE__*/React.createElement("img", {
    src: "".concat(contextRoot, "/fileServer").concat(data.imagePath1),
    alt: "image-1"
  }), (data === null || data === void 0 ? void 0 : data.imagePath2) && /*#__PURE__*/React.createElement("img", {
    src: "".concat(contextRoot, "/fileServer").concat(data.imagePath2),
    alt: "image-2"
  }), (data === null || data === void 0 ? void 0 : data.imagePath3) && /*#__PURE__*/React.createElement("img", {
    src: "".concat(contextRoot, "/fileServer").concat(data.imagePath3),
    alt: "image-3"
  })));
};

MarqueesDialog.propTypes = {
  data: PropTypes.object.isRequired,
  onCloseDailog: PropTypes.func.isRequired
};